import React from "react";

interface ProcessWheelIconProps {
  className?: string;
}

const ProcessWheelIcon: React.FC<ProcessWheelIconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      height="26"
      viewBox="0 0 24 24"
      width="26"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6" />
      <circle cx="12" cy="12" r="3.4" stroke="currentColor" strokeWidth="1.6" />
      <path
        d="M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.6 2.6M15.8 15.8l2.6 2.6M18.4 5.6l-2.6 2.6M8.2 15.8l-2.6 2.6"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.4"
      />
    </svg>
  );
};

export default ProcessWheelIcon;
